var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"app-topbar",style:(_vm.computedStyles)},[_c('ul',{staticClass:"app-topbar__menu"})])
}
var staticRenderFns = []

export { render, staticRenderFns }